<template>
  <div>
    <formTitle title="申請人語言 Applicant’s Language"></formTitle>
    <el-form
      ref="applicantLanguage"
      label-position="top"
      :model="applicantLanguage"
      label-width="80px"
    >
      <div
        v-for="(items, indexs) in applicantLanguage.applicantLanguages"
        :key="indexs"
      >
        <el-form-item :label="setLabel(indexs)">
          <el-radio-group v-model="items.LanguageType">
            <el-radio
              :disabled="isView"
              v-for="(item, index) in applicantLanguages"
              :key="index"
              :label="item.value"
              >{{ item.label }}
              
              <el-input class="radio-input" v-if="item.value == 3" :disabled="isView || items.LanguageType !== 3"  v-model="items.language"></el-input>
               
              </el-radio
            >
          </el-radio-group>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import formTitle from "@/components/formTitle";
export default {
  components: {
    formTitle,
  },
  props: {
    applicantLanguage: {
      type: Object,
      default: function () {},
    },
    isView: {
      type: Boolean,
      default: false,
    },
    adminEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      applicantLanguages: [
        {
          label: "英語 English",
          value: 0,
        },
        {
          label: "普通話 Putonghua",
          value: 1,
        },
        {
          label: "廣東話 Cantonese",
          value: 2,
        },
         {
          label: "其他 Others",
          value: 3,
        },
      ],
    };
  },
  methods: {
    setLabel(index) {
      let newLabel = "";
      switch (index) {
        case 0:
          newLabel = "第一語言 First language";
          break;
        case 1:
          newLabel = "第二語言 Second language ";
          break;
        case 2:
          newLabel = "家中主要使用語言 Spoken Language at Home";
          break;
      }
      return newLabel;
    },
    onBack() {
      this.$emit("personalBackgroundBack");
    },
    onSave() {
      this.$emit("personalBackgroundSave");
    },
    onSaveAndContinue() {
      this.$emit("personalBackgroundSaveAndContinue");
    },
  },
};
</script>

<style lang="scss" scoped>
.el-button--primary {
  width: auto;
}
.radio-input{
  width: fit-content;
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .el-radio{
    margin-bottom: 0.625rem;
  }
}
</style>